<template>
  <div id="dashboard-notification" v-if="automatedmessages.data != null" v-loading="automatedmessages.loading">
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in automatedmessages.data.cards.slice(0,-1)" :key="index">
        <div class="data-card purple">
          <div class="card-info">
            <div class="title">
              <span>{{ item.title }}</span>
            </div>
            <div class="value">
              <span>{{ item.value }}</span>
            </div>
            <div class="description">
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div class="card-icon">
            <i :class="item.icon"></i>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.notification.voucherEmails") }}</h3>
          </div>
          <div class="pie-chart-container">
            <upgrade-overlay position="absolute" lottieWidth="150px" v-if="false" size="small"></upgrade-overlay>
            <div ref="emailvoucher-chart" id="emailvoucher-chart" class="chart"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.notification.voucherSms") }}</h3>
          </div>
          <div class="pie-chart-container">
            <upgrade-overlay position="absolute" lottieWidth="150px" v-if="false" size="small"></upgrade-overlay>

            <div ref="smsvoucher-chart" id="smsvoucher-chart" class="chart"></div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.notification.automaticEmails") }}</h3>
          </div>
          <div class="pie-chart-container">
            <upgrade-overlay position="absolute" lottieWidth="150px" v-if="false" size="small"></upgrade-overlay>

            <div ref="automatedmessages-chart" id="automatedmessages-chart" class="chart"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { C } from "caniuse-lite/data/agents";

export default {
  components: {},
  name: "Notification",
  data() {
    return {
      emailvoucherchart: null,
      smsvoucherchart: null,
      automatedmessageschart: null,
      infoemailschart: null
    };
  },
  methods: {
    createDummySet() {
      var dummyData = [
        {
          key: "Kuyrukta",
          value: Math.floor(Math.random() * 100) + 1,
          color: "#FFD100"
        },
        {
          key: "Gönderildi",
          value: Math.floor(Math.random() * 100) + 1,
          color: "#6457F9"
        },
        {
          key: "İletildi",
          value: Math.floor(Math.random() * 100) + 1,
          color: "#ACE60F"
        },
        {
          key: "Okundu",
          value: Math.floor(Math.random() * 100) + 1,
          color: "#50BFBF"
        },
        {
          key: "Hata Oluştu",
          value: Math.floor(Math.random() * 100) + 1,
          color: "#FF6565"
        }
      ];
      return dummyData;
    },
    downloadReport() {
      axios.post("report/generalstatistics", {}).then(res => {
        this.$message.success(res.data.alert.message);
      });
    },
    createPieChartEmailVoucher() {
      var chart = am4core.create("emailvoucher-chart", am4charts.PieChart);
      if (true) {
        chart.data = this.automatedmessages.data.chartDataEmailVouchers.datasets;
      } else {
        chart.data = this.createDummySet();
      }
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      chart.legend = new am4charts.Legend();
      chart.legend.maxWidth = undefined;
      chart.legend.valueLabels.template.align = "left";
      chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.emailvoucherchart = chart;
    },
    createPieChartSmsVoucher() {
      var chart = am4core.create("smsvoucher-chart", am4charts.PieChart);
      if (true) {
        chart.data = this.automatedmessages.data.chartDataSmsVouchers.datasets;
      } else {
        chart.data = this.createDummySet();
      }
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      chart.legend = new am4charts.Legend();
      chart.legend.maxWidth = undefined;
      chart.legend.valueLabels.template.align = "left";
      chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.smsvoucherchart = chart;
    },
    createPieChartAutomatedMessages() {
      var chart = am4core.create("automatedmessages-chart", am4charts.PieChart);
      if (true) {
        chart.data = this.automatedmessages.data.chartDataAutomatedMessages.datasets;
      } else {
        chart.data = this.createDummySet();
      }
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      chart.legend = new am4charts.Legend();
      chart.legend.maxWidth = undefined;
      chart.legend.valueLabels.template.align = "left";
      chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.automatedmessageschart = chart;
    },
    createPieChartInfoEmails() {
      var chart = am4core.create("infoemails-chart", am4charts.PieChart);
      if (true) {
        chart.data = this.automatedmessages.data.chartDataInformationEmails.datasets;
      } else {
        chart.data = this.createDummySet();
      }
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      chart.legend = new am4charts.Legend();
      chart.legend.maxWidth = undefined;
      chart.legend.valueLabels.template.align = "left";
      chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.infoemailschart = chart;
    }
  },

  async mounted() {
    if (this.automatedmessages.data == null) {
      await this.$store.dispatch("getAutomatedMessages", {});
      this.$nextTick(() => {
        this.createPieChartEmailVoucher();
        this.createPieChartSmsVoucher();
        this.createPieChartAutomatedMessages();
        this.createPieChartInfoEmails();
      });
    } else {
      if (this.chart == null) {
        this.createPieChartEmailVoucher();
        this.createPieChartSmsVoucher();
        this.createPieChartAutomatedMessages();
        this.createPieChartInfoEmails();
      }
    }

    this.$watch("automatedmessages.loading", function() {
      if (true) {
        this.emailvoucherchart.data = this.automatedmessages.data.chartDataEmailVouchers.datasets;
        this.smsvoucherchart.data = this.automatedmessages.data.chartDataSmsVouchers.datasets;
        this.automatedmessageschart.data = this.automatedmessages.data.chartDataAutomatedMessages.datasets;
        this.infoemailschart.data = this.automatedmessages.data.chartDataInformationEmails.datasets;
      } else {
        this.emailvoucherchart.data = this.createDummySet();
        this.smsvoucherchart.data = this.createDummySet();
        this.automatedmessageschart.data = this.createDummySet();
        this.infoemailschart.data = this.createDummySet();
      }
    });
  },

  computed: {
    automatedmessages() {
      return this.$store.getters.getDashboardAutomatedMessages;
    },
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    }
  },

  beforeDestroy() {
    if (this.emailvoucherchart || this.smsvoucherchart || this.automatedmessageschart || this.infoemailschart) {
      this.emailvoucherchart.dispose();
      this.smsvoucherchart.dispose();
      this.automatedmessageschart.dispose();
      this.infoemailschart.dispose();
    }
  },

  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Notification.vue